import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';

export type Props = {
  open: boolean,
  onClose: () => void,
  /** 読み込み先（デフォルト: /legal.html） */
  src?: string,
  /** ダイアログタイトル（任意） */
  title?: string,
};

const LegalDialog: React.FC<Props> = ({
  open, onClose, src = '/legal.html', title = '免責事項（詳細）',
}) => {
  const [html, setHtml] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let ignore = false;
    async function load() {
      setError(null);
      try {
        const res = await fetch(src, { cache: 'no-store' });
        if (!res.ok) throw new Error(`${res.status}`);
        const text = await res.text();
        if (!ignore) setHtml(text);
      } catch (e: any) {
        if (!ignore) setError('免責事項の読み込みに失敗しました。後ほど再度お試しください。');
      }
    }
    if (open && html == null && !error) {
      load();
    }
    return () => { ignore = true; };
  }, [error, html, open, src]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ textAlign: 'center' }}>
        {title}
      </DialogTitle>
      <DialogContent>
        {!html && !error && (
          <Typography variant="body2">読み込み中...</Typography>
        )}
        {error && (
          <Typography variant="body2" color="error">{error}</Typography>
        )}
        {html && (
          <Box
            sx={{
              maxHeight: 500,
              overflow: 'auto',
              bgcolor: '#fafafa',
              borderRadius: 1,
              p: 2,
            }}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={onClose}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LegalDialog;
